import api from '@/utils/api';

/**
 * delete company option
 *
 * @param {string} companyId - The company id
 * @param {string} id - The option id
 * @returns {Promise} The promise object of the api call
 */
const deleteCompanyTemplateApi = (companyId, id) =>
  api.delete(`company/${companyId}/template/${id}`);

export default deleteCompanyTemplateApi;
